<div class="shop-products-page" fxLayout="column" fxLayoutAlign="start center">
    <aw-wizard class="wizard-design shop-wizard shop-products-wizard">
        <aw-wizard-step
            class="shop-products-step" [stepTitle]="'PRODUCTS_STEP' | translate">
            <div class="shop-products-hero shop-page-heading shop-page-heading--center" fxLayout="column" fxLayoutAlign="center center">
                <div class="shop-page-heading__copy">
                    <h1 class="shop-page-heading__title">{{ 'CHOOSE_YOUR_PRODUCT' | translate }}</h1>
                    <p class="shop-page-heading__subtitle">{{ 'SELECT_THE_TYPE_OF_CAMPAIGN_YOU_WANT_TO_SET_UP' | translate }}</p>
                </div>
            </div>

            <div *ngIf="doneLoading && ((userRoles.includes(1)) || (userRoles.includes(2)) || (userRoles.includes(4)) || (userRoles.includes(3)) || (userRoles.includes(10)) || (userRoles.includes(12)))" class="shop-products-toolbar mb-3" fxLayout="row wrap" fxLayoutAlign="space-between center">
                <div class="shop-products-company-filter">
                    <p>{{ 'PLEASE_SELECT_A_COMPANY' | translate }}</p>
                    <ng-select class="shop-products-company-select" [items]="this.allMyCompanies" bindLabel="name" bindValue="id" (change)="onCompanyChange($event)"></ng-select>
                </div>
                <div *ngIf="(allProducts.length / pageSize) > 1" class="pagination-rounded shop-products-pagination">
                    <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                        [collectionSize]="allProducts.length" [page]="pageNumber" [boundaryLinks]="true"
                        (pageChange)="onPageChange($event)" [pageSize]="pageSize">
                    </ngb-pagination>
                </div>
            </div>    
            <p style="font-style: italic; text-align: center;">{{ 'CREDIT_CARD_SURCHARGE_NOTICE' | translate }}</p>
            <div class="shop-products-grid" fxLayout="row wrap" fxLayoutGap="32px" fxLayoutAlign="start stretch">
                
                <ng-container *ngFor="let p of tempProducts">
                    <app-product-tile (click)="onAddtoCart(p.id)" [product]="p" fxFlex.xs="100%" fxFlex.sm="33%" fxFlex="0 1 calc(33.3% - 32px)"></app-product-tile>
                </ng-container>
            </div>
            <div *ngIf="(allProducts.length / pageSize) > 1" class="shop-products-pagination shop-products-pagination--footer" fxLayout="row" fxLayoutAlign="end center">
                <div class="pagination-rounded">
                    <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                        [collectionSize]="allProducts.length" [page]="pageNumber" [boundaryLinks]="true"
                        (pageChange)="onPageChange($event)" [pageSize]="pageSize">
                    </ngb-pagination>
                </div>
            </div>    
        </aw-wizard-step>
        <aw-wizard-step
            class="shop-products-step shop-products-step--placeholder" [stepTitle]="'LOCATION' | translate">
        </aw-wizard-step>
        <aw-wizard-step
            class="shop-products-step shop-products-step--placeholder" [stepTitle]="'AD_SPEND' | translate">
        </aw-wizard-step>
        <aw-wizard-step
            class="shop-products-step shop-products-step--placeholder" [stepTitle]="'CHECKOUT' | translate">
        </aw-wizard-step>
    </aw-wizard>
</div>
